import {
    GET_REPORT_TYPES,
    GET_USERS,
    SET_WEEK,
    SET_YEAR,
    SET_USER
} from "./types";

const INITIAL_STATE = {
    reportTypes: false,
    users: false,
    selectedWeek: false,
    selectedYear: false,
    selectedUser: "all_users",
    requesting: false
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_REPORT_TYPES.REQUEST: {
            return { ...state, requesting: true, reportTypes: false };
        }
        case GET_REPORT_TYPES.FAIL: {
            return { ...state, requesting: false, reportTypes: false };
        }
        case GET_REPORT_TYPES.SUCCESS: {
            return { ...state, requesting: false, reportTypes: action.payload };
        }
        case GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case SET_WEEK: {
            return { ...state, selectedWeek: action.payload };
        }
        case SET_YEAR: {
            return { ...state, selectedYear: action.payload };
        }
        case SET_USER: {
            return { ...state, selectedUser: action.payload };
        }
        default: {
            return { ...state };
        }
    }
};
